import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=015de462"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015de462')) {
      api.createRecord('015de462', component.options)
    } else {
      api.reload('015de462', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=015de462", function () {
      api.rerender('015de462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Button.vue"
export default component.exports